import { CurrencyEnum } from "@finway-group/shared/lib/models/common/currency.enum"
import Col from "antd/lib/col"
import Collapse from "antd/lib/collapse"
import Row from "antd/lib/row"
import React, { useState } from "react"

import { CurrencySelect } from "Components/forms/expenseForm/commonInputFields/CurrencySelect"

import { FormCategoryEnum, FormInputEnum, FormMinMaxCurrencyInterface } from "./form.types"
import FormInputElem from "./formInputElem"

export function FormMinMaxCurrency({ header, min, max, currency = CurrencyEnum.EUR, keyCode = "" }: FormMinMaxCurrencyInterface) {
    const [activeCategory, setActiveCategory] = useState({
        isMin: !!min.initialValue,
        isMax: !!max.initialValue,
    })

    return (
        <Collapse ghost defaultActiveKey={keyCode} className={activeCategory.isMin || activeCategory.isMax ? "filter--active" : ""}>
            <Collapse.Panel header={header} key={keyCode} forceRender>
                <Row gutter={[16, 16]} className="mb-8 mt-0">
                    <FormInputElem
                        elem={{ ...min, inputType: FormInputEnum.NUMBER }}
                        span={9}
                        activeCategory={activeCategory}
                        setActiveCategory={setActiveCategory}
                        category={FormCategoryEnum.MIN}
                    />
                    <FormInputElem
                        elem={{ ...max, inputType: FormInputEnum.NUMBER }}
                        span={9}
                        activeCategory={activeCategory}
                        setActiveCategory={setActiveCategory}
                        category={FormCategoryEnum.MAX}
                    />
                    <Col span={6} className="p-0 pl-10">
                        <CurrencySelect initialValue={currency} label="" size="small" />
                    </Col>
                </Row>
            </Collapse.Panel>
        </Collapse>
    )
}
